/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemGroupModifierCreateRequestSchema } from "./mobileOrderItemGroupModifierCreateRequestSchema.ts";

export const mobileOrderItemGroupUnionModifierCreateRequestSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(mobileOrderItemGroupModifierCreateRequestSchema),
});
